export default "__VITE_ASSET__BhS8MKja__"